module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "book-pages---regular"
  }, [_c('span', {
    staticClass: "charoverride"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "book-pages---regular"
  }, [_c('span', {
    staticClass: "charoverride"
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "book-list-no-italic"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "book-list-no-italic"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("This book is for Michael Warby,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("peerless researcher, dear friend, il magnifico")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f87b59a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Dedication.vue
// module id = 69
// module chunks = 0